<template>
  <scout-tab-panel
    :is-active="isActive"
    :link="link"
    title="会員検索"
    name="search"
  />
</template>

<script>
import ScoutTabPanel from '@/components/atoms/ScoutTabPanel'
import { mapGetters } from 'vuex'

export default {
  components: { ScoutTabPanel },
  props: {
    jobId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters('contracts', {
      jobBy: 'jobBy'
    }),
    isActive () {
      return this.$route.path.includes('/search')
    },
    link () {
      if (this.searchConditionId === 0) { // searchConditionIdはdefaultで0
        // 検索条件が1件もないため、検索条件新規作成画面に飛ばす
        return {
          name: 'scoutSearch',
          params: {
            create: true,
            jobId: this.jobId,
            contractId: this.$route.params.contractId
          }
        }
      } else {
        return { name: 'scoutSearchResult' }
      }
    },
    searchConditionId () {
      return Number(this.jobBy(this.$route.params.contractId, this.jobId).searchConditionId)
    }
  }
}
</script>
